import { UploadImageBlockProps } from './type';

interface Props {
  blockProps: UploadImageBlockProps;
  scaleFactor?: number;
}

export const ImageUploadBlock: React.FC<Props> = (props) => {
  const { blockProps, scaleFactor = 1 } = props;
  const { url, label, height, isUploadImage, width } = blockProps;

  const value =
    blockProps?.[blockProps?.mappingKey as keyof UploadImageBlockProps];
  const imageUrl = url ? url : value ? value : `data:image/jpeg;base64,${url}`;

  return (
    <>
      <div
        style={{
          width: `${width * scaleFactor}px`,
          height: `${height * scaleFactor}px`,
        }}
      >
        <img
          src={imageUrl}
          alt={label}
          style={{
            width: width * scaleFactor,
            height: height * scaleFactor,
            objectFit: 'contain',
          }}
        />
      </div>
    </>
  );
};
